import React, {Suspense} from "react";
import { Route } from "react-router-dom";
import ErrorBoundary from '../ErrorBoundary'

const childfn = ({ component: C, props: cProps, ...rest }) =>
  <Suspense fallback={<div>Loading...</div>}>
    <Route {...rest} render={props => <ErrorBoundary><C {...props} {...cProps} /></ErrorBoundary>} />
  </Suspense>

export default childfn;
